module.exports = __webpack_public_path__ + "static/img/5.533b328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/5.png
// module id = Vgh/
// module chunks = 0